import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ec451314&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec451314')) {
      api.createRecord('ec451314', component.options)
    } else {
      api.reload('ec451314', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ec451314&lang=pug&", function () {
      api.rerender('ec451314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/navigationButtons/index.vue"
export default component.exports